(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8898],{

/***/ 18986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./containers/layout/header/header.module.scss
var header_module = __webpack_require__(48818);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(6684);
// EXTERNAL MODULE: ./contexts/theme/theme.context.tsx
var theme_context = __webpack_require__(80108);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./containers/searchContainer/searchContainer.module.scss
var searchContainer_module = __webpack_require__(87857);
var searchContainer_module_default = /*#__PURE__*/__webpack_require__.n(searchContainer_module);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(22120);
// EXTERNAL MODULE: ./hooks/useDebounce.tsx
var useDebounce = __webpack_require__(48606);
// EXTERNAL MODULE: ./hooks/useDidUpdate.tsx
var useDidUpdate = __webpack_require__(68416);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(1612);
// EXTERNAL MODULE: ./services/product.ts
var product = __webpack_require__(32837);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useUserLocation.tsx
var useUserLocation = __webpack_require__(2950);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(34349);
// EXTERNAL MODULE: ./redux/slices/search.ts
var search = __webpack_require__(20330);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(21697);
;// CONCATENATED MODULE: ./containers/searchContainer/searchContainer.tsx















const PopoverContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4678), __webpack_require__.e(5724), __webpack_require__.e(5537)]).then(__webpack_require__.bind(__webpack_require__, 56060)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56060)
            ]
    }
});
const SearchResult = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9526), __webpack_require__.e(2742)]).then(__webpack_require__.bind(__webpack_require__, 52742)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52742)
            ]
    }
});
const SearchSuggestions = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4935).then(__webpack_require__.bind(__webpack_require__, 54935)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54935)
            ]
    }
});
const shopRoutes = [
    "shop/"
];
function SearchContainer(param) {
    let { searchContainerRef  } = param;
    var ref, ref1;
    const { t , i18n  } = (0,es/* useTranslation */.$G)();
    const locale = i18n.language;
    const { settings  } = (0,settings_context/* useSettings */.r)();
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const debouncedSearchTerm = (0,useDebounce/* default */.Z)(searchTerm.trim(), 400);
    const [anchorEl, setAnchorEl] = (0,react.useState)(null);
    const open = Boolean(anchorEl);
    const [anchorSuggestion, setAnchorSuggestion] = (0,react.useState)(null);
    const openSuggestion = Boolean(anchorSuggestion);
    const { pathname , query  } = (0,router.useRouter)();
    const isRestaurantRoute = shopRoutes.some((item)=>pathname.includes(item));
    const location = (0,useUserLocation/* default */.Z)();
    const dispatch = (0,useRedux/* useAppDispatch */.T)();
    const history = (0,useRedux/* useAppSelector */.C)(search/* selectSearchHistory */.ag);
    const { data: shops , fetchNextPage: fetchShopsNextPage , hasNextPage: hasShopsNextPage , isFetchingNextPage: isFetchingShopsNextPage , isLoading: isShopsLoading  } = (0,react_query_es.useInfiniteQuery)([
        "shopResult",
        debouncedSearchTerm,
        location,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.search */.Z.search({
            search: debouncedSearchTerm,
            page: pageParam,
            address: location,
            open: 1
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        },
        retry: false,
        enabled: !!debouncedSearchTerm && !isRestaurantRoute
    });
    const { data: products , fetchNextPage: fetchProductsNextPage , hasNextPage: hasProductsNextPage , isFetchingNextPage: isFetchingProductsNextPage , isLoading: isProductsLoading  } = (0,react_query_es.useInfiniteQuery)([
        "productResult",
        debouncedSearchTerm,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return product/* default.search */.Z.search({
            search: debouncedSearchTerm,
            page: pageParam,
            shop_id: isRestaurantRoute ? query.id : undefined,
            address: location
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        },
        retry: false,
        enabled: !!debouncedSearchTerm,
        onSuccess: ()=>{
            dispatch((0,search/* addToSearch */.fy)(debouncedSearchTerm));
        }
    });
    const handleOpen = ()=>setAnchorEl(searchContainerRef.current);
    const handleClose = ()=>setAnchorEl(null);
    const handleOpenSuggestion = ()=>setAnchorSuggestion(searchContainerRef.current);
    const handleCloseSuggestion = ()=>setAnchorSuggestion(null);
    const handleClick = ()=>{
        handleOpenSuggestion();
        if (debouncedSearchTerm) {
            handleOpen();
            handleCloseSuggestion();
        }
    };
    (0,useDidUpdate/* default */.Z)(()=>{
        if (debouncedSearchTerm) {
            handleOpen();
            handleCloseSuggestion();
        } else {
            handleClose();
            handleOpenSuggestion();
        }
    }, [
        debouncedSearchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (searchContainer_module_default()).search,
        ref: searchContainerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                id: "search",
                placeholder: isRestaurantRoute ? "".concat(t("search.in"), " ").concat(t("this.shop")) : "".concat(t("search.on"), " Gloco"),
                autoComplete: "off",
                value: searchTerm,
                onChange: (event)=>setSearchTerm(event.target.value),
                onClick: handleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContainer, {
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                anchorPosition: {
                    left: 30,
                    top: 30
                },
                disableAutoFocus: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult, {
                    isVisibleShops: !isRestaurantRoute,
                    shops: (shops === null || shops === void 0 ? void 0 : (ref = shops.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [],
                    products: (products === null || products === void 0 ? void 0 : (ref1 = products.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap((item)=>item.data)) || [],
                    isLoading: isShopsLoading || isProductsLoading,
                    handleClickItem: handleClose,
                    productTotal: (products === null || products === void 0 ? void 0 : products.pages) ? products.pages[0].meta.total : 0,
                    shopTotal: (shops === null || shops === void 0 ? void 0 : shops.pages) ? shops.pages[0].meta.total : 0,
                    isFetchingShopsNextPage: isFetchingShopsNextPage,
                    isFetchingProductsNextPage: isFetchingProductsNextPage,
                    hasProductsNextPage: !!hasProductsNextPage,
                    hasShopsNextPage: !!hasShopsNextPage,
                    fetchProductsNextPage: fetchProductsNextPage,
                    fetchShopsNextPage: fetchShopsNextPage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContainer, {
                open: openSuggestion && !!history.length,
                anchorEl: anchorSuggestion,
                onClose: handleCloseSuggestion,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                anchorPosition: {
                    left: 30,
                    top: 30
                },
                disableAutoFocus: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSuggestions, {
                    setSearchTerm: setSearchTerm
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(29969);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(37490);
// EXTERNAL MODULE: ./containers/addressContainer/addressContainer.tsx
var addressContainer = __webpack_require__(41380);
// EXTERNAL MODULE: ./components/cartButton/cartButton.tsx
var cartButton = __webpack_require__(4253);
// EXTERNAL MODULE: ./components/notificationStats/notificationStats.tsx
var notificationStats = __webpack_require__(61105);
;// CONCATENATED MODULE: ./containers/layout/header/header.tsx















const AppDrawer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4678), __webpack_require__.e(7533), __webpack_require__.e(1998), __webpack_require__.e(4898)]).then(__webpack_require__.bind(__webpack_require__, 44898)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(44898)
            ]
    }
});
const ProfileDropdown = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4678), __webpack_require__.e(5724), __webpack_require__.e(1998), __webpack_require__.e(1502)]).then(__webpack_require__.bind(__webpack_require__, 21502)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21502)
            ]
    }
});
function Header() {
    const { t  } = (0,es/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    const { isDarkMode  } = (0,react.useContext)(theme_context/* ThemeContext */.N);
    const { isAuthenticated , user , openAuthModal  } = (0,auth_context/* useAuth */.a)();
    const [appDrawer, handleOpenAppDrawer, handleCloseAppDrawer] = (0,useModal/* default */.Z)();
    const searchContainerRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((header_module_default()).container, " ").concat(pathname !== "/" && (header_module_default()).bordered),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: (header_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (header_module_default()).navItem,
                            children: [
                                !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (header_module_default()).menuBtn,
                                    onClick: handleOpenAppDrawer,
                                    "aria-label": "menu",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: (header_module_default()).menuIcon,
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M1.66699 14.1667C1.66699 14.625 2.04199 15 2.50033 15H17.5003C17.9587 15 18.3337 14.625 18.3337 14.1667C18.3337 13.7083 17.9587 13.3333 17.5003 13.3333H2.50033C2.04199 13.3333 1.66699 13.7083 1.66699 14.1667ZM1.66699 10C1.66699 10.4583 2.04199 10.8333 2.50033 10.8333H17.5003C17.9587 10.8333 18.3337 10.4583 18.3337 10C18.3337 9.54167 17.9587 9.16667 17.5003 9.16667H2.50033C2.04199 9.16667 1.66699 9.54167 1.66699 10ZM1.66699 5.83333C1.66699 6.29167 2.04199 6.66667 2.50033 6.66667H17.5003C17.9587 6.66667 18.3337 6.29167 18.3337 5.83333C18.3337 5.375 17.9587 5 17.5003 5H2.50033C2.04199 5 1.66699 5.375 1.66699 5.83333Z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    className: (header_module_default()).brandLogo,
                                    children: isDarkMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BrandLogoDark */.$C, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BrandLogo */.Oc, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((header_module_default()).navItem, " ").concat((header_module_default()).searchBar),
                            ref: searchContainerRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).search,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContainer, {
                                    searchContainerRef: searchContainerRef
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).navItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(addressContainer/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(notificationStats/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).navItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cartButton/* default */.Z, {})
                        }),
                        isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDropdown, {
                            data: user
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: openAuthModal,
                            className: (header_module_default()).login,
                            children: t("login")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDrawer, {
                open: appDrawer,
                handleClose: handleCloseAppDrawer
            })
        ]
    });
}


/***/ }),

/***/ 48606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    const [debounceValue, setDebounceValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebounceValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debounceValue;
}


/***/ }),

/***/ 68416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useDidUpdate = (f, conditions)=>{
    const didMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        // Cleanup effects when f returns a function
        return f && f(); //eslint-disable-line
    }, conditions);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDidUpdate);


/***/ }),

/***/ 2950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserLocation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21697);


function useUserLocation() {
    const { location: userLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .useSettings */ .r)();
    const location = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const latlng = userLocation;
        if (!latlng) {
            return undefined;
        }
        return {
            latitude: latlng.split(",")[0],
            longitude: latlng.split(",")[1]
        };
    }, [
        userLocation
    ]);
    return location;
}


/***/ }),

/***/ 32837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);
// services/product.ts

const productService = {
    // liste
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/paginate", {
            params
        }),
    getAllShopProducts: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/products"), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/search", {
            params
        }),
    getViewed: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/product-histories/paginate", {
            params
        }),
    // singolo prodotto
    // UUID (legacy): /rest/products/:uuid
    getById: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        }),
    // **NUMERICO**: /rest/products/id/:id  --> quello che useremo nella pagina
    getByIdNumber: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/id/".concat(id), {
            params
        }),
    // bulk per ids (rimane com’è)
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/ids", {
            params
        }),
    // alias temporaneo (deprecato)
    getByIdLegacyUuid: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (productService);


/***/ }),

/***/ 1612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25728);

const shopService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?".concat(params)),
    // getAllBooking: (params: string): Promise<Paginate<IShop>> =>
    //   request.get(`/rest/booking/shops/paginate?${params}`),
    // getAllRestaurants: (params: string): Promise<Paginate<IBookingShop>> =>
    //   request.get(`/rest/shops/paginate?type=restaurant&${params}`),
    // getAllShops: (params: string): Promise<Paginate<IShop>> =>
    //   request.get(`/rest/shops/paginate?type=shop&${params}`),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/search", {
            params
        }),
    getAllTags: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-takes", {
            params
        }),
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/user/shops", data),
    checkZone: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/delivery-zone/check/distance", {
            params
        }),
    checkZoneById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/".concat(id, "/delivery-zone/check/distance"), {
            params
        }),
    getVisitedShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-histories/paginate", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (shopService);


/***/ }),

/***/ 48818:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__EWEDv","bordered":"header_bordered__qCmHl","header":"header_header__SAJHp","navItem":"header_navItem__7Y6f4","brandLogo":"header_brandLogo__A0_aV","menuBtn":"header_menuBtn__Vexr0","menuIcon":"header_menuIcon__zsYWN","search":"header_search__EipNy","searchBar":"header_searchBar__kGcPB","actions":"header_actions__rbgla","iconBtn":"header_iconBtn__Is3SD","login":"header_login__moAd5"};

/***/ }),

/***/ 87857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"searchContainer_search__Z8MFl"};

/***/ })

}]);